<template>
	<app-page>
		<app-heading :title="isNew ? 'New Sponsor' : sponsor.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'marketsponsors' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="sponsor.name"
					required
					:errors="errors.name"
				/>
				<input-text
					label="Agent Name"
					v-model="sponsor.agent"
					required
					:errors="errors.agent"
				/>
				<input-text
					type="email"
					label="Email"
					v-model="sponsor.email"
					required
					:errors="errors.email"
				/>
				<input-text
					type="phone"
					label="Phone"
					v-model="sponsor.phone"
					required
					:errors="errors.phone"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			sponsor: {
				name: '',
				agent: '',
				email: '',
				phone: '',
			},
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.sponsor
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.sponsor = await this.$ravello.request()
					.v(2)
					.to('marketsponsors')
					.to(this.id)
					.get()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			const request = this.$ravello.request()
				.v(2)
				.to('marketsponsors')

			const payload = {
				name: this.sponsor.name,
				agent: this.sponsor.agent,
				email: this.sponsor.email,
				phone: this.sponsor.phone,
			}
			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request.to(this.id).update(payload)
				}

				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Sponsor successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'marketsponsors' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
